var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSegment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 15.5H16.6667C17.125 15.5 17.5 15.125 17.5 14.6667C17.5 14.2083 17.125 13.8333 16.6667 13.8333H8.33333C7.875 13.8333 7.5 14.2083 7.5 14.6667C7.5 15.125 7.875 15.5 8.33333 15.5ZM2.5 6.33333C2.5 6.79167 2.875 7.16667 3.33333 7.16667H16.6667C17.125 7.16667 17.5 6.79167 17.5 6.33333C17.5 5.875 17.125 5.5 16.6667 5.5H3.33333C2.875 5.5 2.5 5.875 2.5 6.33333ZM8.33333 11.3333H16.6667C17.125 11.3333 17.5 10.9583 17.5 10.5C17.5 10.0417 17.125 9.66667 16.6667 9.66667H8.33333C7.875 9.66667 7.5 10.0417 7.5 10.5C7.5 10.9583 7.875 11.3333 8.33333 11.3333Z",
    fill: "#546881"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegment);
export default __webpack_public_path__ + "static/media/segment.2d745305998464fdb1bb933146bb3591.svg";
export { ForwardRef as ReactComponent };